import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

export const seriesActionClassName =
    "flex items-center gap-2 rounded-full border bg-background px-3 py-1";

export function SeriesAction({ className, ...props }: ComponentProps<"div">) {
    return <div className={cn(seriesActionClassName, className)} {...props} />;
}
